module.exports = "<img *ngIf=\"!items\" class=\"loader u-center\" src=\"/assets/images/loader_small.gif\">\n\n<app-poster *ngIf=\"items\" data-touch-action=\"none\" [style.visibility]=\"LayoutService.showSplashscreen ? 'hidden' : 'visible'\" [items]=\"items\" [startPosition]=\"startPosition\" [poster]=\"poster\"></app-poster>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home-view/home-view.component.html
// module id = ./src/app/home-view/home-view.component.html
// module chunks = main